import { getGraphQlJsonResponse, getJsonResponse } from '../../../../utils/ApiUtils';
import { LegacyCustomer } from '../../../../interfaces/api/Customer';
import { Order } from '../../../../interfaces/Table';

type CustomerReturnType = { items: LegacyCustomer[]; total: number };

export const fetchCustomers = async (fetch: any, orderBy: string, order: Order): Promise<CustomerReturnType> => {
  const returnFields =
    'id, dateCreate, agency{id}, installationSite{ socialReason, coordinate }, assignedEmployeeInformatique{id}, assignedEmployeeTelecom{id}';
  const graphQlKey = 'customers';

  const filters = {
    socialReason: null,
    socialReasonOperator: '"Contient"',
    dateCreateStart: null,
    dateCreateEnd: null,
    dateCreateOperator: null,
    termination: false,
    liquidation: false,
    creatorIdsOperator: '"Fait partie de"',
    creatorIds: null,
    professionalFieldIdsOperator: '"Fait partie de"',
    professionalFieldIds: null,
    orderBy,
    ASC: order === 'asc',
  };

  const filtersString = Object.keys(filters)
    .map((filterKey) => `${filterKey}:${filters[filterKey]}`)
    .join(', ');

  const response = await fetch(`/api/customer/{${graphQlKey}(${filtersString}){items{${returnFields}}, total}}`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    method: 'GET',
  });

  const customersStateResponse = await fetch(`/api/customer/states`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    method: 'GET',
  });

  const customersState = await getJsonResponse<Record<number, LegacyCustomer['state']>>(customersStateResponse);
  const customers = await getGraphQlJsonResponse<CustomerReturnType>(graphQlKey, response);

  customers.items = customers.items.map((customer) => ({
    ...customer,
    state: customer.id in customersState ? customersState[customer.id] : 'lost',
  }));

  return customers;
};
